// production plans

export default [
    {
        map_key: 'standard_yearly',
        group_key: 'standard',
        label: 'Standard',
        billing_interval: 'yearly',
        description: 'Small group coaching lessons',
        stripe_product_id: 'prod_OipbJLTuE4W9T0',
        stripe_price_id: 'price_1NvNwVIDrm6Z6HgYWA4z0Ims',
        price: 22800,
        price_monthly: 1900,
        free_hardware: true,
        free_hardware_categories: ['bat_attachment'],
        includes_coaching: false,
        badge: '40% OFF',
        hardware_options: [],
    },
    {
        map_key: 'standard_monthly',
        group_key: 'standard',
        label: 'Standard',
        billing_interval: 'monthly',
        description: 'Small group coaching lessons',
        stripe_product_id: 'prod_OipbJLTuE4W9T0',
        stripe_price_id: 'price_1NvNwVIDrm6Z6HgYHQ624kUW',
        price: 2900,
        price_monthly: 2900,
        free_hardware: false,
        free_hardware_categories: [],
        includes_coaching: false,
        badge: '',
        hardware_options: [],
    },
    {
        map_key: 'pro_yearly',
        group_key: 'pro',
        label: 'Pro',
        billing_interval: 'yearly',
        description: 'Small group coaching lessons',
        stripe_product_id: 'prod_OO0ajV3G9DhXNB',
        stripe_price_id: 'price_1OrSHrIDrm6Z6HgYRXI1AFZh',
        price: 35500,
        price_monthly: 2958,
        free_hardware: true,
        free_hardware_categories: ['short_bat'],
        includes_coaching: true,
        badge: '30% OFF',
        hardware_options: [],
    },
    {
        is_archived: true,
        map_key: 'pro_yearly',
        group_key: 'pro',
        label: 'Pro',
        billing_interval: 'yearly',
        description: 'Small group coaching lessons',
        stripe_product_id: 'prod_OO0ajV3G9DhXNB',
        stripe_price_id: 'price_1OHtZ0IDrm6Z6HgYE1DoZCwr',
        price: 29900,
        price_monthly: 2500,
        free_hardware: true,
        free_hardware_categories: ['short_bat'],
        includes_coaching: true,
        badge: '40% OFF',
        hardware_options: [],
    },
    {
        is_archived: true,
        map_key: 'pro_yearly',
        group_key: 'pro',
        label: 'Pro',
        billing_interval: 'yearly',
        description: 'Small group coaching lessons',
        stripe_product_id: 'prod_OO0ajV3G9DhXNB',
        stripe_price_id: 'price_1ODDweIDrm6Z6HgYu0H1jhEQ',
        price: 30000,
        price_monthly: 2500,
        free_hardware: true,
        free_hardware_categories: ['short_bat'],
        includes_coaching: true,
        badge: '40% OFF',
        hardware_options: [],
    },
    {
        map_key: 'pro_monthly',
        group_key: 'pro',
        label: 'Pro',
        billing_interval: 'monthly',
        description: 'Small group coaching lessons',
        stripe_product_id: 'prod_OO0ajV3G9DhXNB',
        stripe_price_id: 'price_1ODDw3IDrm6Z6HgYzIRCjuCK',
        price: 3900,
        price_monthly: 3900,
        badge: '',
        free_hardware: true,
        free_hardware_categories: ['bat_attachment'],
        includes_coaching: true,
        hardware_options: [],
    },
    {
        map_key: 'elite_yearly',
        group_key: 'elite',
        label: 'Elite Academy',
        billing_interval: 'yearly',
        description: '1-on-1 coaching lessons',
        stripe_product_id: 'prod_OO0bq380dBg5v4',
        stripe_price_id: 'price_1NbEaeIDrm6Z6HgYpeeDmb4H',
        price: 106800,
        price_monthly: 8900,
        free_hardware: true,
        free_hardware_categories: ['bat_attachment'],
        includes_coaching: true,
        badge: 'Save $120+',
        hardware_options: [],
    },
    {
        map_key: 'elite_monthly',
        group_key: 'elite',
        label: 'Elite Academy',
        billing_interval: 'monthly',
        description: '1-on-1 coaching lessons',
        stripe_product_id: 'prod_OO0bq380dBg5v4',
        stripe_price_id: 'price_1NbEaeIDrm6Z6HgYcm0dWJOj',
        price: 9900,
        price_monthly: 9900,
        free_hardware: true,
        free_hardware_categories: ['bat_attachment'],
        includes_coaching: true,
        badge: '',
        hardware_options: [],
    },
] as StripePlan[]
